import { useCallback } from "react";
import { Product } from "src/graphql/generated/graphql";
import { productByEANQuery } from "src/graphql/operations/products/queries";
import { graphqlFetch } from "src/graphql/utils/graphqlFetch";

import { handleError } from "../utils/error";

export const productImageCrop = {
    minWidth: 500,
    aspectRatio: {
        value: 16 / 11,
        label: "16 / 11",
    },
};

export const useQueryProductByEAN = () => {
    const queryProductByEAN = useCallback(async (ean: string, excludeProductId?: string): Promise<Product> => {
        try {
            const response = await graphqlFetch(productByEANQuery, { ean, excludeProductId });

            return response.productByEAN;
        } catch (err) {
            handleError(err, {
                message: { key: "product_load_failed", namespace: "common" },
                context: { ean, excludeProductId },
            });
            return null;
        }
    }, []);

    return {
        queryProductByEAN,
    };
};
